import type { ReactNode } from "react";

type UserProfileSectionHeaderProps = {
  icon: string;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export default function UserProfileSectionHeader({
  icon,
  title,
  description,
  actions,
  className = "",
}: UserProfileSectionHeaderProps) {
  return (
    <div
      className={`user-profile-section-header${
        className ? ` ${className}` : ""
      }`}
    >
      <div className="user-profile-section-title user-profile-section-header-title">
        <span className="material-symbols-outlined" aria-hidden="true">
          {icon}
        </span>
        <div>
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
      </div>
      {actions}
    </div>
  );
}
